import { render, staticRenderFns } from "./cly-breadcrumbs.vue?vue&type=template&id=5b93c2be"
import script from "./cly-breadcrumbs.vue?vue&type=script&lang=js"
export * from "./cly-breadcrumbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports